import axios from 'axios';
import googleAnalyticsClient from '../common/google_analytics/ajax_handling';
import StoreBadges from '../common/store_badges';
import karteErrorClient from '../common/karte/error';
import karteCustonEventClient from '../common/karte/custom_event';

document.addEventListener('DOMContentLoaded', () => {
  const bulkNewDiv = document.getElementById('leaflet_bulk_imports_bulk_new') as HTMLElement;
  if (bulkNewDiv == null) {
    return;
  }

  const storeBadgesClient = new StoreBadges();
  const uploadArea = document.getElementById('upload_files_area') as HTMLElement;
  const table = document.querySelector('table.leaflet-bulk-import-list') as HTMLElement;
  const submitButton = document.querySelector('.leaflet-bulk-import-upload-button') as HTMLElement;
  const submitGbpButton = document.querySelector('.leaflet-bulk-import-upload-gbp-button') as HTMLElement;
  const submitDraftButton = document.querySelector('.leaflet-bulk-import-draft-upload-button') as HTMLElement;
  const uploadStatus = document.getElementById('files_uploading_status') as HTMLElement;
  const uploadCompleted = document.getElementById('files_upload_completed') as HTMLElement;
  const uploadFailed = document.getElementById('files_upload_failed') as HTMLElement;
  const confirmationFailed = document.getElementById('files_confirmation_failed') as HTMLElement;
  const filesUploadFailedDetails = document.getElementById('files_upload_failed_details') as HTMLElement;
  const filesConfirmationFailedDetails = document.getElementById('files_confirmation_failed_details') as HTMLElement;
  const uploadCancel = document.getElementById('files_uploading_status_cancel') as HTMLElement;
  const failedFilesDetailsFileNamesUl = document.getElementById('failed_files_details_file_names') as HTMLElement;
  const downloadFailedFiles = document.getElementById('download_failed_files') as HTMLElement;
  const uploadingStatusBar = document.getElementById('uploading_status_bar') as HTMLElement;
  const failedFilesDetailsCloseButton = document.getElementById('failed_files_details_close') as HTMLElement;
  const failedFilesDetailsCover = document.getElementById('failed_files_details_cover') as HTMLElement;
  const parallelProcessingNum = 5;
  const leafletFilePeriods = document.querySelectorAll('.leaflet-file-period');
  const changeAllFilePeriod = document.querySelector('.change-all-file-period') as HTMLElement;
  const startHourOfDayBeforeInput = document.getElementById('start_hour_of_day_before') as HTMLInputElement;

  bulkNewDiv.addEventListener('drop', (event) => {
    event.preventDefault();
  });

  bulkNewDiv.addEventListener('dragover', (event) => {
    event.preventDefault();
    (event.dataTransfer as DataTransfer).dropEffect = 'copy';
  });

  uploadArea.addEventListener('drop', (event) => {
    event.preventDefault();
    removeClassDropping();
    const files = (event.dataTransfer as DataTransfer).files;
    const uploadData = setFiles(files);
    uploadFilesInParallel(uploadData);
  });

  uploadArea.addEventListener('dragover', (event) => {
    event.preventDefault();
    (event.dataTransfer as DataTransfer).dropEffect = 'copy';
    addClassDropping();
  });

  uploadArea.addEventListener('dragleave', (event) => {
    event.preventDefault();
    removeClassDropping();
  });

  const addClassDropping = () => {
    uploadArea.classList.add('dropping');
  }

  const removeClassDropping = () => {
    uploadArea.classList.remove('dropping');
  }

  const setFiles = (files: FileList) => {
    var data = new Array;
    var faiedFileCount = 0;
    [].forEach.call(files, file => {
      const images = findLeafletFileImages(file as File);
      if (images.length) {
        [].forEach.call(images, image => {
          if (checkJpegFile(file)) {
            const reader = new FileReader();
            reader.addEventListener('load', (e) => {
              if ((e.target as FileReader).result) {
                (image as HTMLImageElement).src = (e.target as any).result || '';
              }
            });
            // 画像データを読み込む
            reader.readAsDataURL(file);
          } else {
            // PDFファイル
            const readyPdfPath = (image as HTMLImageElement).dataset.readyPdfPath || '';
            (image as HTMLImageElement).src = readyPdfPath;
          }
          // アップロードのためのIDを取得
          const leafletBulkImportStoreGroupFileId = (image as HTMLElement).dataset.leafletBulkImportStoreGroupFileId;
          // ファイルのindexを取得
          const registrationOrder = (image as HTMLElement).dataset.registrationOrder;
          // UUIDを生成
          const uuid = generateUuid();
          (image as HTMLElement).dataset.uuid = uuid;
          data.push({
            leafletBulkImportStoreGroupFileId: leafletBulkImportStoreGroupFileId,
            file: file,
            uuid: uuid,
            registrationOrder: registrationOrder
          });
        });
      } else {
        // 一致するファイルが存在しなかった場合
        faiedFileCount += 1;
        addConfirmationFailedFileName(file, faiedFileCount);
      }
    });
    if (0 < faiedFileCount) {
      // 一致するファイルが存在しなかった場合
      const filesUploadFailedMessage = document.getElementById('files_confirmation_failed_message') as HTMLElement;
      filesUploadFailedMessage.innerHTML = faiedFileCount + '件のファイルのアップロードに失敗しました<br>詳細を確認し、適切なファイルを再度アップロードしてください';
      setTimeout(() => {
        showConfirmationFailed();
      }, 1000);
    } else {
      hideConfirmationFailed();
    }
    return data;
  }

  const findLeafletFileImage = (leafletBulkImportStoreGroupFileId: string) => {
    const images = table.querySelectorAll('.leaflet-file-image');
    var returnedImage = null;
    [].forEach.call(images, image => {
      const assumedLeafletBulkImportStoreGroupFileId = (image as HTMLElement).dataset.leafletBulkImportStoreGroupFileId;
      if (assumedLeafletBulkImportStoreGroupFileId == leafletBulkImportStoreGroupFileId) {
        returnedImage = image;
      }
    });
    return returnedImage;
  }

  const findLeafletFileImages = (file: File) => {
    const fileName = file.name;
    const images = table.querySelectorAll('.leaflet-file-image');
    var returnedImages = new Array;
    [].forEach.call(images, image => {
      const assumedFileName = (image as HTMLElement).dataset.filename;
      if (assumedFileName == fileName) {
        returnedImages.push(image);
      }
    });
    return returnedImages;
  }

  const checkJpegFile = (file: File) => {
    return (file.type == 'image/jpeg');
  }

  const findLeafletFileCheckBox = (leafletBulkImportStoreGroupFileId: string) => {
    const checkboxes = document.querySelectorAll('.leaflet-bulk-import-store-group-file-id-check-box');
    var targetCheckBox = null;
    [].forEach.call(checkboxes, checkbox => {
      if ((checkbox as HTMLInputElement).value == leafletBulkImportStoreGroupFileId) {
        targetCheckBox = checkbox;
      }
    });
    return targetCheckBox;
  }

  const generateUuid = () =>  {
    // https://github.com/GoogleChrome/chrome-platform-analytics/blob/master/src/internal/identifier.js
    // const FORMAT: string = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx";
    let chars = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".split("");
    for (let i = 0, len = chars.length; i < len; i++) {
      switch (chars[i]) {
        case "x":
          chars[i] = Math.floor(Math.random() * 16).toString(16);
          break;
        case "y":
          chars[i] = (Math.floor(Math.random() * 4) + 8).toString(16);
          break;
      }
    }
    return chars.join("");
  }

  type resultLeaflet = { result: boolean };
  type resultLeafletFile = { result: boolean };

  const submit = (uploadData: Array<any>, button: HTMLElement, draft: boolean, gbp_integration: boolean = false) => {
    // ファイルを取得
    const files = fetchFiles(uploadData);
    // ファイルが存在する場合
    if (files.length && submitConfirmation(button, gbp_integration)) {
      // 初期化
      showUploadStatus();
      removeCanceledClassFromUploadArea();
      hideUploadFailed();
      hideUploadCompleted();
      hideFailedFilesDetails();
      refreshFailedFileNames();
      removeFailedFileNames();
      removeDownloadFailedFiles();
      setFileNamesToStorage(files);
      initializeUpdateStatusBar();
      hideConfirmationFailed();

      // KARTEに登録イベントを送信
      sendKarteEvent(
        'create_content',
        'leaflets',
        'チラシを一括登録で登録しました'
      );

      // 並列処理
      const fileNames = getFileNames(files);
      const filesCount = files.length as number;
      var uploadedFiles = new Array;
      const per = Math.ceil(filesCount/parallelProcessingNum);
      const sortedUploadFiles = sortUploadFiles(files) as Array<File>;
      var passFlag = false; // アップロードを通すフラグ
      for (var i=0; i<filesCount; i++){
        const breakFlag = ((i+1)%per === 0);
        const lastFileFlag = filesCount === (i+1);
        const file = sortedUploadFiles[i]
        uploadedFiles.push(file);
        if (breakFlag || (!breakFlag && lastFileFlag) || passFlag) {
          const skipFlag = passFlag = detectSkipFlag(file);
          if (lastFileFlag || !skipFlag) {
            const dt = new DataTransfer();
            [].forEach.call(uploadedFiles, file => {
              dt.items.add(file);
            });
            if (0 < dt.files.length) {
              uploadFiles(dt.files, fileNames, draft, gbp_integration);
            }
            // 初期化
            uploadedFiles = new Array;
            // 通すかどうかのフラグをfalseにする
            passFlag = false;
          }
        }
      }
    }
  }

  const uploadFilesInParallel = (uploadData: Array<any>) => {
    submitButton.addEventListener('click', () => {
      submit(uploadData, submitButton, false)
    });
    if (submitGbpButton) {
      submitGbpButton.addEventListener('click', () => {
          submit(uploadData, submitGbpButton, false, true)
      });
    }
    // 下書き機能は限定公開
    if (submitDraftButton) {
      submitDraftButton.addEventListener('click', () => {
        submit(uploadData, submitDraftButton, true)
      });
    }
  }

  const sortUploadFiles = (files: FileList) => {
    var filesArray = new Array;
    [].forEach.call(files, file => {
      filesArray.push(file);
    });
    filesArray = filesArray.sort((file1: File, file2: File) => {
      // 面のファイルかどうか
      const leafletBulkImportStoreGroupFileId1 = (file1 as any).leafletBulkImportStoreGroupFileId;
      const leafletBulkImportStoreGroupFileId2 = (file2 as any).leafletBulkImportStoreGroupFileId;
      const image1 = findLeafletFileImage(leafletBulkImportStoreGroupFileId1);
      const image2 = findLeafletFileImage(leafletBulkImportStoreGroupFileId2);
      if (image1 && image2) {
        const fileIndex1 = parseInt((image1 as HTMLElement).dataset.leafletBulkImportStoreGroupFileId || '');
        const fileIndex2 = parseInt((image2 as HTMLElement).dataset.leafletBulkImportStoreGroupFileId || '');
        if (fileIndex1 < fileIndex2) {
          return -1;
        }
        if (fileIndex1 > fileIndex2) {
          return 1;
        }
      }
      return 0;
    });
    return filesArray;
  }

  const fetchFiles = (uploadData: Array<any>) => {
    const dt = new DataTransfer();
    [].forEach.call(uploadData, hash => {
      const leafletBulkImportStoreGroupFileId = hash['leafletBulkImportStoreGroupFileId'];
      // 重複ファイルがあるため、コピーする
      const originalFile = hash['file'] as File;
      const file = Object.assign(new File([originalFile], originalFile.name, { type: originalFile.type }), hash['file']);
      const uuid = hash['uuid'];
      const registrationOrder = hash['registrationOrder'];
      const image = findLeafletFileImage(leafletBulkImportStoreGroupFileId);
      const checkbox = findLeafletFileCheckBox(leafletBulkImportStoreGroupFileId);
      if (image != null && (image as HTMLElement).dataset.uuid == uuid && checkbox != null && (checkbox as HTMLInputElement).checked) {
        (file as any).leafletBulkImportStoreGroupFileId = leafletBulkImportStoreGroupFileId;
        (file as any).imageElement = image;
        (file as any).registrationOrder = registrationOrder;
        dt.items.add(file);
      }
    });
    return dt.files;
  }

  const uploadFiles = (files: FileList, allFileNames: Array<string>, draft: boolean, gbp_integration: boolean) => {
    var currentFileCount = 0;
    uploadCurrentFileName(files[currentFileCount]); // 最初のファイル名を描画
    uploadFilesCount(allFileNames); // 最初の進捗を描画
    uploadFile(files, currentFileCount, allFileNames, draft, gbp_integration);
  }

  const detectSkipFlag = (file: File) => {
    // 面のファイルかどうか
    const leafletBulkImportStoreGroupFileId = (file as any).leafletBulkImportStoreGroupFileId;
    const image = findLeafletFileImage(leafletBulkImportStoreGroupFileId);
    var skipFlag = false;
    if (image != null) {
      skipFlag = (image as HTMLElement).dataset.skipFlag == 'true';
    }
    return skipFlag;
  }

  const uploadFile = (files: FileList, currentFileCount: number, allFileNames: Array<string>, draft: boolean, gbp_integration: boolean) => {
    if (checkUploadCancel()) {
      return; // cancledクラスを持っていればキャンセルする
    }
    const file = files[currentFileCount];
    const formData = new FormData();
    const filesCount = files.length;
    const leafletBulkImportStoreGroupFileId = (file as any).leafletBulkImportStoreGroupFileId;
    const startHourOfDayBefore = startHourOfDayBeforeInput.value;
    const registrationOrder = (file as any).registrationOrder;
    formData.append('file', file);
    formData.append('leaflet_bulk_import_store_group_file_id', leafletBulkImportStoreGroupFileId);
    if (draft) {
      formData.append('draft', 'true');
    }
    if (gbp_integration) {
      formData.append('gbp_integration', 'true');
    }
    formData.append('start_hour_of_day_before', startHourOfDayBefore);
    formData.append('registration_order', registrationOrder);
    const token = (document.getElementsByName('csrf-token')[0] as HTMLElement).getAttribute('content');
    axios
      .post<resultLeaflet>('/staff/api/leaflet_bulk_imports/create_leaflet_for_leaflet_bulk_import', formData, {
        headers: {
          'content-type': 'multipart/form-data',
          'X-CSRF-Token': token
        }
      })
      .then(response => {
        const data = response.data;
        if (data['result']) {
          // アップロード成功
          successFileUpload(file);
          showCompletedUploadOnImage(file);
        } else {
          // アップロード失敗
          failFileUpload(file)
          addFailedFileName(file, allFileNames);
          showErrorUploadOnImage(file);
        }
        currentFileCount += 1;
        updateStatusBar(allFileNames);
        uploadFilesCount(allFileNames);
        // 次の処理 or 処理完了
        if (currentFileCount != filesCount) {
          uploadCurrentFileName(files[currentFileCount]);
          uploadFile(files, currentFileCount, allFileNames, draft, gbp_integration);
        } else {
          showUploadFinished(allFileNames);
        }
      }).catch(error => {
        // 汎用版チラシ一括登録のチラシアップロード処理でエラー発生
        const errorPath = '/staff/api/leaflet_bulk_imports/create_leaflet_for_leaflet_bulk_import';
        const errorMessage = '汎用版チラシ一括登録のチラシアップロード処理でエラー発生';
        const el = document.querySelector<HTMLElement>('#staff_infomation');
        const staffId = el?.dataset.staffId;
        const now = el?.dataset.now;

        if(staffId && now) {
          googleAnalyticsClient.error({
            time: now,
            path: errorPath,
            staffId: staffId,
            message: errorMessage
          });
        }

        if (!hasRetryCancelFlag() && confirm('ネットワークエラーが発生しました。リトライしますか？')) {
          uploadFile(files, currentFileCount, allFileNames, draft, gbp_integration);
        } else {
          // アップロード失敗を処理する
          addRetryCancelFlag();
          for (var i=currentFileCount; i<filesCount; i++){
            failFileUpload(files[currentFileCount])
            addFailedFileName(files[currentFileCount], allFileNames);
            currentFileCount += 1;
            if ((i+1) == filesCount) {
              showUploadFinished(allFileNames);
            }
          }
        }
      });
  }

  const addRetryCancelFlag = () => {
    (uploadStatus as HTMLElement).classList.add('retry-canceled');
  }

  const removeRetryCancelFlag = () => {
    (uploadStatus as HTMLElement).classList.remove('retry-canceled');
  }

  const hasRetryCancelFlag = () => {
    return (uploadStatus as HTMLElement).classList.contains('retry-canceled');
  }

  const setFileNamesToStorage = (files: FileList) => {
    [].forEach.call(files, file => {
      localStorage.setItem(generateFileKey((file as File).name), 'yet'); // データセット
    });
  }

  const generateFileKey = (fileName: string) => {
    return ('leafletBulkNew-' + fileName);
  }

  const getFileNames = (files: FileList) => {
    var names = new Array;
    [].forEach.call(files, file => {
      names.push((file as File).name);
    });
    return names;
  }

  const successFileUpload = (file: File) => {
    localStorage.setItem(generateFileKey(file.name), 'true'); // 成功
  }

  const failFileUpload = (file: File) => {
    localStorage.setItem(generateFileKey(file.name), 'false'); // 成功
  }

  const getSucceededFileCount = (allFileNames: Array<string>) => {
    var files = new Array;
    [].forEach.call(allFileNames, fileName => {
      const key = generateFileKey(fileName)
      if (localStorage.getItem(key) == 'true') {
        files.push(fileName);
      }
    });
    return files.length;
  };

  const getFaiedFileCount = (allFileNames: Array<string>) => {
    var files = new Array;
    [].forEach.call(allFileNames, fileName => {
      const key = generateFileKey(fileName)
      if (localStorage.getItem(key) == 'false') {
        files.push(fileName);
      }
    });
    return files.length;
  };

  const getYetFileCount = (allFileNames: Array<string>) => {
    var files = new Array;
    [].forEach.call(allFileNames, fileName => {
      const key = generateFileKey(fileName);
      if (localStorage.getItem(key) == 'yet') {
        files.push(fileName);
      }
    });
    return files.length;
  };

  const showUploadStatus = () => {
    (uploadStatus as HTMLElement).style.display = 'block';
  }

  const hideUploadStatus = () => {
    (uploadStatus as HTMLElement).style.display = 'none';
  }

  const uploadCurrentFileName = (file: File) => {
    const currentUploadFileName = document.getElementById('current_upload_file_name');
    (currentUploadFileName as HTMLElement).innerText = file.name + ' をアップロード中...';
  }

  const uploadFilesCount = (allFileNames: Array<string>) => {
    const filesCount = allFileNames.length;
    const currentFileCount = filesCount - getYetFileCount(allFileNames);
    const filesUploadingCount = document.getElementById('files_uploading_count');
    (filesUploadingCount as HTMLElement).innerText = '(' + currentFileCount + ' / ' + filesCount + 'ファイル)';
  }

  const updateStatusBar = (allFileNames: Array<string>) => {
    const filesCount = allFileNames.length;
    const currentFileCount = filesCount - getYetFileCount(allFileNames);
    (uploadingStatusBar as HTMLElement).style.width = ((currentFileCount/filesCount) * 100) + '%';
    if (currentFileCount == filesCount) {
      (uploadingStatusBar as HTMLElement).classList.add('completed');
    }
  }

  const initializeUpdateStatusBar = () => {
    (uploadingStatusBar as HTMLElement).style.width = '0';
  }

  const showUploadFinished = (allFileNames: Array<string>) => {
    const succeededFileCount = getSucceededFileCount(allFileNames);
    const faiedFileCount = getFaiedFileCount(allFileNames);
    if (getYetFileCount(allFileNames) != 0) {
      // 処理が完了していない
      return;
    }
    removeRetryCancelFlag();
    // submitボタンを再度機能するようにする
    changeSubmittedClassubmitButtons(false);
    if (0 < faiedFileCount) {
      // エラーあり
      const filesUploadFailedMessage = document.getElementById('files_upload_failed_message') as HTMLElement;
      filesUploadFailedMessage.innerText = faiedFileCount + '件のファイルのアップロードに失敗しました';
      setTimeout(() => {
        hideUploadStatus();
        showUploadFailed();
      }, 3000);
    } else {
      // アップロード完了
      const filesUploadCompletedMessage = document.getElementById('files_upload_completed_message');
      (filesUploadCompletedMessage as HTMLElement).innerText = succeededFileCount + '件のファイルをアップロードしました';
      setTimeout(() => {
        hideUploadStatus();
        showUploadCompleted();
      }, 3000);
    }
  }

  const refreshFailedFileNames = () => {
    const lis = (failedFilesDetailsFileNamesUl as HTMLElement).children;
    [].forEach.call(lis, li => {
      (li as HTMLElement).remove();
    });
  }

  const removeFailedFileNames = () => {
    (failedFilesDetailsFileNamesUl as HTMLElement).innerHTML = '';
  }

  const addFailedFileName = (file: File, allFileNames: Array<string>) => {
    const failedFilesDetailsTitle = document.getElementById('failed_files_details_title');
    const li = document.createElement('li');
    const nameDiv = document.createElement('div');
    const sizeDiv = document.createElement('div');
    const faiedFileCount = getFaiedFileCount(allFileNames);
    nameDiv.classList.add('file-name');
    sizeDiv.classList.add('file-size');
    nameDiv.innerText = file.name;
    sizeDiv.innerText = bytesToSize(file.size);
    li.appendChild(nameDiv);
    li.appendChild(sizeDiv);
    (failedFilesDetailsFileNamesUl as HTMLElement).appendChild(li);
    (failedFilesDetailsTitle as HTMLElement).innerText = 'エラーファイル一覧' + ' (' + faiedFileCount + '件)';
    (downloadFailedFiles as HTMLElement).dataset.failedFiles += file.name + "\n";
  }

  const addConfirmationFailedFileName = (file: File, faiedFileCount: number) => {
    const failedFilesDetailsTitle = document.getElementById('failed_files_details_title');
    const li = document.createElement('li');
    const nameDiv = document.createElement('div');
    const sizeDiv = document.createElement('div');
    nameDiv.classList.add('file-name');
    sizeDiv.classList.add('file-size');
    nameDiv.innerText = file.name;
    sizeDiv.innerText = bytesToSize(file.size);
    li.appendChild(nameDiv);
    li.appendChild(sizeDiv);
    (failedFilesDetailsFileNamesUl as HTMLElement).appendChild(li);
    (failedFilesDetailsTitle as HTMLElement).innerText = 'エラーファイル一覧' + ' (' + faiedFileCount + '件)';
    (downloadFailedFiles as HTMLElement).dataset.failedFiles += file.name + "\n";
  }

  const bytesToSize = (bytes: any) => {
    if      (bytes >= 1073741824) { bytes = (bytes / 1073741824).toFixed(2) + " GB"; }
    else if (bytes >= 1048576)    { bytes = (bytes / 1048576).toFixed(2) + " MB"; }
    else if (bytes >= 1024)       { bytes = (bytes / 1024).toFixed(2) + " KB"; }
    else if (bytes > 1)           { bytes = bytes + " bytes"; }
    else if (bytes == 1)          { bytes = bytes + " byte"; }
    else                          { bytes = "0 bytes"; }
    return bytes;
  }

  filesUploadFailedDetails.addEventListener('click', () => {
    showFailedFilesDetails();
    hideUploadFailed();
  });

  filesConfirmationFailedDetails.addEventListener('click', () => {
    showFailedFilesDetails();
    hideConfirmationFailed();
  });

  const cancelUpload = () => {
    addCanceledClassToUploadArea();
    hideUploadStatus();
  }

  uploadCancel.addEventListener('click', () => {
    if (confirm('本当にキャンセルしますか？')) {
      cancelUpload();
    }
  });

  downloadFailedFiles.addEventListener('click', () => {
    var text = ((downloadFailedFiles as HTMLElement).dataset.failedFiles as string);
    downloadAsTextFile('エラーファイル一覧.txt', text);
  });

  failedFilesDetailsCloseButton.addEventListener('click', () => {
    hideFailedFilesDetails();
  });

  failedFilesDetailsCover.addEventListener('click', () => {
    hideFailedFilesDetails();
  });

  const addCanceledClassToUploadArea = () => {
    uploadArea.classList.add('canceled');
  }

  const removeCanceledClassFromUploadArea = () => {
    uploadArea.classList.remove('canceled');
  }

  const checkUploadCancel = () => {
    return uploadArea.classList.contains('canceled');
  }

  window.addEventListener('beforeunload', event => {
    if (checkUploading()) {
      event.preventDefault();
      event.returnValue = 'データ送信中です。\n本当に離脱しますか？';
    }
  });

  const checkUploading = () => {
    return uploadStatus.style.display == 'block';
  }

  const showUploadCompleted = () => {
    uploadCompleted.style.display = 'flex';
  }

  const hideUploadCompleted = () => {
    uploadCompleted.style.display = 'none';
  }

  const showUploadFailed = () => {
    uploadFailed.style.display = 'flex';
  }

  const hideUploadFailed = () => {
    uploadFailed.style.display = 'none';
  }

  const showConfirmationFailed = () => {
    confirmationFailed.style.display = 'flex';
  }

  const hideConfirmationFailed = () => {
    confirmationFailed.style.display = 'none';
  }

  const showFailedFilesDetails = () => {
    const failedFilesDetails = document.getElementById('failed_files_details');
    (failedFilesDetails as HTMLElement).style.display = 'block';
  }

  const hideFailedFilesDetails = () => {
    const failedFilesDetails = document.getElementById('failed_files_details');
    (failedFilesDetails as HTMLElement).style.display = 'none';
  }

  const removeDownloadFailedFiles = () => {
    (downloadFailedFiles as HTMLElement).dataset.failedFiles = '';
  }

  const downloadAsTextFile = (fileName: string, content: string) => {
    const blobText = new Blob([ content ], { 'type': 'text/plain' });
    const canUseSaveBlob = window.navigator.msSaveBlob !== undefined;
    if ( canUseSaveBlob ) {
      window.navigator.msSaveBlob(blobText, fileName);
      return;
    }

    const tempAnchor = document.createElement( 'a' );
    tempAnchor.href = URL.createObjectURL(blobText);
    tempAnchor.setAttribute('download', fileName);

    tempAnchor.dispatchEvent( new MouseEvent( 'click' ) );
  };

  const showErrorUploadOnImage = (file: File) => {
    const image = (file as any).imageElement;
    if (image != null) {
      image.parentElement.classList.add('error');
    }
  };

  const showCompletedUploadOnImage = (file: File) => {
    const image = (file as any).imageElement;
    if (image != null) {
      image.parentElement.classList.add('completed');
    }
  };

  const changeSubmittedClassubmitButtons = (submitted: boolean) => {
    if (submitted) {
      submitButton.classList.add('submitted');
      if(submitGbpButton){
        submitGbpButton.classList.add('submitted');
      }
      // 下書き機能は限定公開
      if (submitDraftButton) {
        submitDraftButton.classList.add('submitted');
      }
    } else {
      submitButton.classList.remove('submitted');
      if(submitGbpButton) {
        submitGbpButton.classList.remove('submitted');
      }
      // 下書き機能は限定公開
      if (submitDraftButton) {
        submitDraftButton.classList.remove('submitted');
      }
    }
    // 送信ボタンの状態を更新
    toggleSubmitButton();
  }

  const submitConfirmation = (button: HTMLElement, gbp_integration: boolean) => {
    const message = gbp_integration ? 'GBPに連携します。アップロードを開始しますか？' : 'アップロードを開始しますか？';
    if (button.classList.contains('submitted')) {
      return true;
    } else if (confirm(message)) {
      changeSubmittedClassubmitButtons(true);
      return true;
    } else {
      return false;
    }
  }

  const checkboxes = document.querySelectorAll('.leaflet-bulk-import-store-group-file-id-check-box');
  const allCheckBox = document.getElementById('all_check_for_leaflet_bulk_import_store_group_file_ids');

  const toggleSubmitButton = () => {
    const checkedBoxes = document.querySelectorAll('.leaflet-bulk-import-store-group-file-id-check-box:checked');
    if (checkedBoxes.length == 0 || submitButton.classList.contains('submitted') || (submitGbpButton && submitGbpButton.classList.contains('submitted'))) {
      submitButton.classList.add('disabled');
      submitButton.innerText = 'チェックしたグループを一括登録';
      if (submitGbpButton) {
        submitGbpButton.classList.add('disabled');
        submitGbpButton.innerText = 'チェックしたグループを一括登録(GBP連携)';
      }
      // 下書き機能は限定公開
      if (submitDraftButton) {
        submitDraftButton.classList.add('disabled');
        submitDraftButton.innerText = 'チェックしたグループを下書き保存';
      }
    } else {
      submitButton.classList.remove('disabled');
      submitButton.innerText = 'チェックしたグループを一括登録' + ' (全' + checkedBoxes.length + '件)';
      if (submitGbpButton) {
        submitGbpButton.classList.remove('disabled');
        submitGbpButton.innerText = 'チェックしたグループを一括登録(GBP連携)' + ' (全' + checkedBoxes.length + '件)';
      }
      // 下書き機能は限定公開
      if (submitDraftButton) {
        submitDraftButton.classList.remove('disabled');
        submitDraftButton.innerText = 'チェックしたグループを下書き保存' + ' (全' + checkedBoxes.length + '件)';
      }
    }
  };

  // チェックボックスがクリックされるごとに実行
  checkboxes.forEach(checkbox => {
    checkbox.addEventListener('change', () => {
      toggleSubmitButton();
    });
  });

  const checkBoxTds = table.querySelectorAll('td.check-box');
  checkBoxTds.forEach(checkBoxTd => {
    const checkbox = checkBoxTd.querySelector('input') as HTMLInputElement;
    checkBoxTd.addEventListener('click', (e) => {
      if ((e.target as HTMLElement).tagName != 'INPUT') {
        checkbox.click();
      }
    });
  });

  if (allCheckBox != null) {
    (allCheckBox as HTMLElement).addEventListener('change', () => {
      if ((allCheckBox as HTMLInputElement).checked) {
        checkboxes.forEach(checkbox => {
          if (!(checkbox as HTMLInputElement).disabled) {
            (checkbox as HTMLInputElement).checked = true;
          }
        });
      } else {
        checkboxes.forEach(checkbox => {
          (checkbox as HTMLInputElement).checked = false;
        });
      }
      toggleSubmitButton();
    });
  }

  // 時間を変更する
  if (changeAllFilePeriod) {
    changeAllFilePeriod.addEventListener('click', () => {
      if (confirm('全ての掲載期間を変更しますか？')) {
        const allLeafletFilePeriod = document.querySelector('.all-leaflet-file-period') as HTMLElement;
        // startTime
        const startTime1i = allLeafletFilePeriod.querySelector('select[id$=start_time_1i]') as HTMLSelectElement;
        const startTime2i = allLeafletFilePeriod.querySelector('select[id$=start_time_2i]') as HTMLSelectElement;
        const startTime3i = allLeafletFilePeriod.querySelector('select[id$=start_time_3i]') as HTMLSelectElement;
        const startTime4i = allLeafletFilePeriod.querySelector('select[id$=start_time_4i]') as HTMLSelectElement;
        const startTime5i = allLeafletFilePeriod.querySelector('select[id$=start_time_5i]') as HTMLSelectElement;
        // endTime
        const endTime1i = allLeafletFilePeriod.querySelector('select[id$=end_time_1i]') as HTMLSelectElement;
        const endTime2i = allLeafletFilePeriod.querySelector('select[id$=end_time_2i]') as HTMLSelectElement;
        const endTime3i = allLeafletFilePeriod.querySelector('select[id$=end_time_3i]') as HTMLSelectElement;
        const endTime4i = allLeafletFilePeriod.querySelector('select[id$=end_time_4i]') as HTMLSelectElement;
        const endTime5i = allLeafletFilePeriod.querySelector('select[id$=end_time_5i]') as HTMLSelectElement;
        if (leafletFilePeriods.length) {
          leafletFilePeriods.forEach(leafletFilePeriod => {
            // startTime
            selectValue((leafletFilePeriod.querySelector('select[id$=start_time_1i]') as HTMLSelectElement), startTime1i.value);
            selectValue((leafletFilePeriod.querySelector('select[id$=start_time_2i]') as HTMLSelectElement), startTime2i.value);
            selectValue((leafletFilePeriod.querySelector('select[id$=start_time_3i]') as HTMLSelectElement), startTime3i.value);
            selectValue((leafletFilePeriod.querySelector('select[id$=start_time_4i]') as HTMLSelectElement), startTime4i.value);
            selectValue((leafletFilePeriod.querySelector('select[id$=start_time_5i]') as HTMLSelectElement), startTime5i.value);
            // endTime
            selectValue((leafletFilePeriod.querySelector('select[id$=end_time_1i]') as HTMLSelectElement), endTime1i.value);
            selectValue((leafletFilePeriod.querySelector('select[id$=end_time_2i]') as HTMLSelectElement), endTime2i.value);
            selectValue((leafletFilePeriod.querySelector('select[id$=end_time_3i]') as HTMLSelectElement), endTime3i.value);
            selectValue((leafletFilePeriod.querySelector('select[id$=end_time_4i]') as HTMLSelectElement), endTime4i.value);
            selectValue((leafletFilePeriod.querySelector('select[id$=end_time_5i]') as HTMLSelectElement), endTime5i.value);
            updateLeafletFile(leafletFilePeriod as HTMLElement);
          });
        }
      }
    });
  }

  const selectValue = (selectElement: HTMLSelectElement, value: string) => {
    const options = selectElement.querySelectorAll('option');
    options.forEach(option => {
      if ((option as HTMLOptionElement).value == value) {
        option.selected = true;
      }
    });
  }

  if (leafletFilePeriods.length) {
    leafletFilePeriods.forEach(leafletFilePeriod => {
      const selects = (leafletFilePeriod as HTMLElement).querySelectorAll('select');
      selects.forEach(select => {
        (select as HTMLSelectElement).addEventListener('change', () => {
          updateLeafletFile(leafletFilePeriod as HTMLElement);
        });
      });
    });
  }

  const updateLeafletFile = (leafletFilePeriod: HTMLElement) => {
    // startTime
    const startTime1i = leafletFilePeriod.querySelector('select[id$=start_time_1i]') as HTMLSelectElement;
    const startTime2i = leafletFilePeriod.querySelector('select[id$=start_time_2i]') as HTMLSelectElement;
    const startTime3i = leafletFilePeriod.querySelector('select[id$=start_time_3i]') as HTMLSelectElement;
    const startTime4i = leafletFilePeriod.querySelector('select[id$=start_time_4i]') as HTMLSelectElement;
    const startTime5i = leafletFilePeriod.querySelector('select[id$=start_time_5i]') as HTMLSelectElement;
    const startTime = startTime1i.value + '-' + startTime2i.value + '-' + startTime3i.value + ' ' + startTime4i.value + ':' + startTime5i.value;
    // endTime
    const endTime1i = leafletFilePeriod.querySelector('select[id$=end_time_1i]') as HTMLSelectElement;
    const endTime2i = leafletFilePeriod.querySelector('select[id$=end_time_2i]') as HTMLSelectElement;
    const endTime3i = leafletFilePeriod.querySelector('select[id$=end_time_3i]') as HTMLSelectElement;
    const endTime4i = leafletFilePeriod.querySelector('select[id$=end_time_4i]') as HTMLSelectElement;
    const endTime5i = leafletFilePeriod.querySelector('select[id$=end_time_5i]') as HTMLSelectElement;
    const endTime = endTime1i.value + '-' + endTime2i.value + '-' + endTime3i.value + ' ' + endTime4i.value + ':' + endTime5i.value;
    // 更新
    const formData = new FormData();
    formData.append('leaflet_bulk_import_store_group_file[start_time]', startTime);
    formData.append('leaflet_bulk_import_store_group_file[end_time]', endTime);
    const path = leafletFilePeriod.dataset.fileUpdatePath || '';
    const token = (document.getElementsByName('csrf-token')[0] as HTMLElement).getAttribute('content');
    axios
      .patch<resultLeafletFile>(path, formData, {
        headers: {
          'content-type': 'multipart/form-data',
          'X-CSRF-Token': token
        }
      })
      .then(response => {
        const data = response.data;
        return data;
      }).catch(error => {
        // 汎用版チラシ一括登録のファイル更新でエラーが発生した
        const errorMessage = '汎用版チラシ一括登録のファイル更新でエラーが発生';
        const el = document.querySelector<HTMLElement>('#staff_infomation');
        const staffId = el?.dataset.staffId;
        const now = el?.dataset.now;

        // エラーイベントを送信 (GA)
        if(staffId && now) {
          googleAnalyticsClient.error({
            time: now,
            path: path,
            staffId: staffId,
            message: errorMessage
          });
        }

        // エラーイベントを送信 (KARTE)
        karteErrorClient.error({
          path: path,
          message: errorMessage
        });

        return error;
      });
  }

  const sendKarteEvent = (event_name: string, content_name: string, message: string) => {
    // 投稿したことをKARTEに通知
    karteCustonEventClient.sendEvent({
      event_name: event_name,
      content_name: content_name,
      message: message
    });
  }

  const initialize = () => {
    toggleSubmitButton();
    storeBadgesClient.initialize(bulkNewDiv);
  }

  // 初期実行
  initialize();
});
